import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>Gallery Hub</h1>
      <h2>Your Pictures</h2>
    </div>
  )
}

export default Title;